import { isB2C, isUkPlatform } from '@/domains/core/settings/utils';

export const useIncentiveVariantEnabled = () => {
  return !isUkPlatform() && isB2C();
};
